import { isFeatureEnabled } from "./appConfigurations";

// Gates the new chart intervals (CS AB#49654): 3/8 hours presets, days from
// midnight, the X axis on the whole interval, grey empty edges and the chart
// drawn when there is no data. Off = the chart as it was before.
export const CHART_INTERVALS_FEATURE_FLAG = "CS_49654_CHART_INTERVALS";

export const selectChartIntervalsEnabled = isFeatureEnabled(
  CHART_INTERVALS_FEATURE_FLAG
);
